module.exports = __webpack_public_path__ + "img/5s.13495671.png";